import { useQuery } from '@tanstack/react-query';

import type { FiatCurrencyCode } from '@/constants/fiatCurrency';
import { FX_RATE_REFRESH_INTERVAL } from '@/constants/fiatCurrency';

import { useCurrencyStore, selectedCurrencySelector, setFxRatesSelector } from '@/store/currency';

import { fetchWithJwt, getFullURL, handleResponse } from '@/utils/fetcher';
import { routes } from '@/utils/routes';

export const fxRatesQueryKey = () => ['fx-rates'] as const;

/** Should be mounted once near the app root. */
export const useFxRates = () => {
  const setFxRates = useCurrencyStore(setFxRatesSelector);
  const selectedCurrency = useCurrencyStore(selectedCurrencySelector);

  return useQuery({
    queryKey: fxRatesQueryKey(),
    queryFn: async () => {
      const response = await fetchWithJwt(getFullURL(routes.api.FX_RATES));
      const data = await handleResponse<Partial<Record<FiatCurrencyCode, number>>>(response);
      setFxRates(data);
      return data;
    },
    enabled: selectedCurrency !== 'USD',
    staleTime: FX_RATE_REFRESH_INTERVAL,
    refetchInterval: FX_RATE_REFRESH_INTERVAL,
  });
};
